import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Get, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useDeletedItems = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["deleted-items", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.DELETED_ITEMS.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useDeleteItemsFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["deleteItemsFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.DELETED_ITEMS.getFacet,
                token,
                toastError: true
            })
            return data
        },
    })
}


export const useRestoreDeletedItem = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Put({
                path: `${API_CONSTANTS.DELETED_ITEMS.base}/${id}/restore`,
                token,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}